import { render } from "./ReagentManagement.vue?vue&type=template&id=7f1c44a7&scoped=true"
import script from "./ReagentManagement.vue?vue&type=script&lang=js"
export * from "./ReagentManagement.vue?vue&type=script&lang=js"

import "./ReagentManagement.vue?vue&type=style&index=0&id=7f1c44a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1c44a7"]])

export default __exports__